<script>
export default {
    components: {},
};
</script>

<template>
<div class="mc-auth">
    <div class="container-fluid">
        <slot />
    </div>
</div>
</template>
